export default {
  /**
   * Tất cả
   */
  None: 0,

  /**
   * Hoạt động
   */
  Action: 1,

  /**
   * Hệ thống
   */
  System: 2,

  /**
   * Khuyến mại
   */
  Promotion: 3,
};
